import { useTranslation } from 'next-i18next';
import { dateGenerator } from 'services/date-generator';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUICalendarDay } from '../product-ui-calendar-day/product-ui-calendar-day';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUITaskCalendarMonth } from '../product-ui-task-calendar-month/product-ui-task-calendar-month';
import { ProductUIView } from '../product-ui-view/product-ui-view';
import type { ReactElement } from 'react';
function CalendarViewScene() {
  const {
    t
  } = useTranslation('productui');
  const tasksMap = new Map([[3, [t('sequence.calendarView.quickAdd'), t('sequence.calendarView.persistentTasks'), t('sequence.calendarView.dragDrop')]], [8, [t('sequence.calendarView.taskDuration')]], [11, [t('sequence.calendarView.teamWorkspaces')]], [17, [t('sequence.calendarView.customerResearch')]], [23, [t('sequence.calendarView.initialSpec')]]]);

  // First day of the first week in the current month
  const firstDay = new Date();
  firstDay.setFullYear(firstDay.getFullYear(), firstDay.getMonth(), 1); // first day of month
  firstDay.setDate(firstDay.getDate() - (firstDay.getDay() || 7)); // first day of that week

  // Last day of the last week in the current month
  const lastDay = new Date();
  lastDay.setFullYear(lastDay.getFullYear(), lastDay.getMonth() + 1, 0); // last day of month
  lastDay.setDate(lastDay.getDate() - lastDay.getDay() + 6); // last day of that week

  const dates = [...dateGenerator(firstDay, lastDay)];
  return <ProductUISceneContainer backgroundVariant="wave-four" appWindowSize="lg" data-sentry-element="ProductUISceneContainer" data-sentry-component="CalendarViewScene" data-sentry-source-file="calendar-view.tsx">
            <ProductUISceneLayer position="bottom" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="calendar-view.tsx">
                <ProductUIAppWindow showSidebar={false} sidebar={<TemplateSidebarStandard />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView variant="calendar">
                                <ProductUIView.Header title={t('sequence.calendarView.title')} showSidebarToggle={true} />
                                <ProductUIView.CalendarView>
                                    {dates.map((date, index) => {
              const taskNames = tasksMap.get(index);
              let tasks: ReactElement[] | undefined = undefined;
              if (taskNames) {
                tasks = taskNames.map(task => <ProductUICalendarDay.Task key={task} taskCircle={<ProductUITaskCalendarMonth.TaskCircle priority="p4" />} text={<ProductUITaskCalendarMonth.Text text={task} />} state="idle" />);
              }
              return <ProductUICalendarDay key={date.toDateString()} date={date} tasks={tasks} />;
            })}
                                </ProductUIView.CalendarView>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="calendar-view.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
export { CalendarViewScene };